export default __webpack_public_path__ + "static/media/lb.924f0dbf.svg";